var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select"},[_c('v-select',_vm._b({style:(_vm.styles),attrs:{"dense":"","menu-props":{ buttom: false, offsetY: true }},on:{"change":function($event){return _vm.emitData($event)}}},'v-select',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }